module.exports = __webpack_public_path__ + "img/benefits-03.c67eb5dd.png";